module.exports = "/assets/5ada98f547b02e5a1c8a40682db35095.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/YM.png
// module id = 2035
// module chunks = 0